import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

// Import Local Styles
import reserving from '~/common/images/reserving.png';
import styles from './completingSignupBlocker.css';

@inject('directPurchaseStore', 'flexFrameStore', 'convertToPaidStore', 'annualUpgradeStore')
@observer
class CompletingSignupBlocker extends Component {
    render() {
        const { creatingAccount } = this.props.convertToPaidStore.isUserConvertingToPaid ? this.props.convertToPaidStore : this.props.directPurchaseStore;
        const { creatingMicroform } = this.props.flexFrameStore;
        const { upgradingUserToAnnual } = this.props.annualUpgradeStore;

        // if number is being locked
        if (creatingAccount || creatingMicroform || upgradingUserToAnnual) {
            return (
                <div className={styles.completingSignupBlocker} data-test="completing-signup-blocker">
                    <img
                        alt="Please wait while we process your order."
                        src={reserving}
                        title="Please wait while we process your order."
                    />

                    { // if accound is being created
                        creatingAccount ?
                            <h1>Please wait while we process your order.</h1>
                            :
                            null
                    }
                    <div className={styles.completingSignupBg}></div>
                </div>
            );
        }
        return null;
    }
}

export default CompletingSignupBlocker;
